module.exports = __webpack_public_path__ + "static/media/nsr.e5c5925d.jpeg";